import { config, $_app_server } from '@/_helpers'
import { api } from '@/_api'
import axios from "axios"

export const userService = {
  login,
  social,
  logout,
  get,
  load,
  check,
  list,
  edit,
}

function auth(url, param) {
  return axios.post(url, param).then(response => {
    let { access_token, grants } = response.data
    localStorage.setItem('access_token', access_token)
    localStorage.setItem('grants', grants)
    $_app_server.defaults.headers.common.Authorization = 'Bearer ' + access_token
    return true
  })
  .catch(error => {
    if (error.response.status === 401) {
      logout()
      return false
    }
  })
}

function login (username, password, social) {
  const security = `username=${username}&password=${password}&social=${social}`
  return auth(config.authUrl, security)
}

function social(source, social_type) {
  return auth(config.socialUrl + social_type + "/token", source)
}

function logout(redirect) {
  if (check()) {
    $_app_server.defaults.headers.common.Authorization = null
    localStorage.removeItem('access_token')
    localStorage.removeItem('grants')
    // location.reload(true)
    window.location = '/'
  }
}

function get() {
  return api.user.current()
}

function load(id) {
  return api.user.get(id);
}

function check() {
  const loggedIn = localStorage.getItem('access_token');
  if (loggedIn) return true;
  return false;
}

function list() {
  return api.user.list()
}

function edit(user) {
  return api.user.edit(user)
}